import {
  UsersResponse as Response,
  Uri,
  UserProfileData,
  convertUserProfile,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useUserProfile(uri: Uri) {
  const { server } = useServer()

  return useQuery({
    queryKey: keys.profile(uri),
    queryFn: fetchUserProfile,
  })

  async function fetchUserProfile(): Promise<UserProfileData> {
    const response = await server.get<Response.User>(decodeURIComponent(uri))
    return convertUserProfile(response)
  }
}
